import { Divider, Spin } from 'antd'
import OrderDetailModalHeader from './blocks/OrderDetailModalHeader'
import OrderDetailModalTable from './blocks/OrderDetailModalTable'
import OrderDetailModalFooter from './blocks/OrderDetailModalFooter'
import { OnCloseModalType } from 'pages/Orders/types'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'

const OrderDetailsModal: React.FC<OnCloseModalType> = ({ onCloseModal }) => {
  const [_, { isLoading}] = useFetchOrderDetailsMutation({
    fixedCacheKey: 'fetchOrderDetails',
  })
  return (
    <>
      {isLoading ? (
        <Spin
          size="large"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '80vh',
          }}
        />
      ) : (
        <>
          <OrderDetailModalHeader />
          <Divider type="horizontal" />
          <OrderDetailModalTable />
          <OrderDetailModalFooter onCloseModal={onCloseModal}/>
        </>
      )}
    </>
  )
}

export default OrderDetailsModal
